import { Button } from '@/_components/ui'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/_components/ui/dialog'
import { AlertTriangle } from 'lucide-react'
import { useState } from 'react'

interface RejectDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirmReject: (reason: string) => void
  isLoading: boolean
}

export const RejectDialog = ({
  open,
  onOpenChange,
  onConfirmReject,
  isLoading,
}: RejectDialogProps) => {
  const [reason, setReason] = useState('')

  const handleReject = () => {
    onConfirmReject(reason)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[460px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-aux-red-danger-1">
              <AlertTriangle className="h-4 w-4 text-aux-red-danger-6" />
            </div>
            <DialogTitle>Rejeitar dados</DialogTitle>
          </div>
          <DialogDescription>
            Ao rejeitar, a solicitação retornará ao status anterior e o paciente precisará informar
            os dados novamente.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <label htmlFor="reject-reason" className="text-sm font-medium text-brand-grayscale-9">
            Motivo da rejeição
          </label>
          <textarea
            id="reject-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Descreva o motivo da rejeição..."
            className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          />
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="gray" disabled={isLoading}>
              Cancelar
            </Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleReject} isLoading={isLoading}>
            Rejeitar dados
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
